export default __webpack_public_path__ + "static/media/map-photo.43bd5e79.png";